import { TableLogisticRoutes } from '../../components'

export const TabLogisticRoutes = () => {
  return (
    <div>
      <TableLogisticRoutes withCarrier={true} />
    </div>
  )
}
